import { createSlice } from '@reduxjs/toolkit';
import { SLICE_NAME } from 'constants/common';
import { remove } from 'lodash';
import { PARTICIPANT_PROPERTY_KEY } from 'pages/mcu/components/constant';

const initialState = {
    participants: [],
    infoRoom: {},
    searchQuery: {
        tab: 0
    },
    isDetailed: false,
    detailDevice: {}
};

export const mcuSlice = createSlice({
    name: SLICE_NAME.MCU,
    initialState,
    reducers: {
        setInfoRoom: (state, action) => {
            state.infoRoom = action.payload;
        },
        updateInfoRoom: (state, action) => {
            state.infoRoom = {
                ...state.infoRoom,
                ...action.payload,
            };
        },
        updateFlagsRoom: (state, action) => {
            state.infoRoom = {
                ...state.infoRoom,
                flags: {
                    ...state.infoRoom?.flags,
                    ...action.payload,
                }
            }
        },
        setParticipants: (state, action) => {
            state.participants = action.payload;
        },
        updateParticipant: (state, action) => {
            const index = state.participants.findIndex((participant) => participant.id === action.payload.id);
            if (index !== -1) {
                state.participants[index] = {
                    ...state.participants[index],
                    ...action.payload,
                };
            }
        },
        addParticipant: (state, action) => {
            state.participants.push(action.payload);
        },
        removeParticipant: (state, action) => {
            remove(state.participants, (participant) => participant.id === action.payload);
        },
        dropAllParticipants: (state) => {
            state.participants = [];
        },
        muteAllParticipants: (state) => {
            state.participants = state.participants.map((participant) => ({
                ...participant,
                [PARTICIPANT_PROPERTY_KEY.MICRO]: 0,
            }));
        },
        unMuteAllParticipants: (state) => {
            state.participants = state.participants.map((participant) => ({
                ...participant,
                [PARTICIPANT_PROPERTY_KEY.MICRO]: 1,
            }));
        },
        clearState: (state) => {
            state.infoRoom = {}
            state.participants = []
        },
        setMCUTab: (state, action) => {
            state.searchQuery.tab = action.payload;
        },
        setIsDetailed: (state, action) => {
            state.isDetailed = action.payload;
        },
        setDetailDevice: (state, action) => {
            state.detailDevice = action.payload;
        }
    },
});

export const {
    setInfoRoom,
    updateInfoRoom,
    setParticipants,
    updateParticipant,
    addParticipant,
    removeParticipant,
    dropAllParticipants,
    muteAllParticipants,
    unMuteAllParticipants,
    updateFlagsRoom,
    clearState,
    setMCUTab,
    setIsDetailed,
    setDetailDevice
} = mcuSlice.actions;
export default mcuSlice.reducer;
